import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './_paginatorControls.css'
import classnames from 'classnames'
import Button from './Button'

export function PaginatorControls ({ first, last, current, gotoPage, prevPage, nextPage, pageButtons, pages }) {

  return (
    <div className={styles.container}>

      {pageButtons && pageButtons.length ?
        <div>
          <Button
            size='small'
            className={classnames(styles.button, styles.prev, {
              [styles.disabled]: first,
            })}
            onClick={prevPage}
            type='default'
          >
            <FormattedMessage
              id='util.pagination_controls.prev'
              defaultMessage='Prev'
            />
          </Button>

          {pageButtons[0] !== 1 ?
            <span className={styles.bookends}>
              <Button
                size='small'
                key='first'
                type='default'
                onClick={() => gotoPage(1)}
                className={classnames(styles.button)}
              >
                {1}
              </Button>
              <span className={styles.ellipsis}>…</span>
            </span>
          : null}

          {pageButtons.map(page => (
            <Button
              size='small'
              key={page}
              type='default'
              onClick={() => gotoPage(page)}
              className={classnames(styles.button, {
                [styles.active]: current === page,
              })}
            >
              {page}
            </Button>
          ))}

          {pageButtons[pageButtons.length - 1] !== pages ?
            <span className={styles.bookends}>
              <span className={styles.ellipsis}>…</span>
              <Button
                size='small'
                key='last'
                type='default'
                onClick={() => gotoPage(pages)}
                className={classnames(styles.button)}
              >
                {pages}
              </Button>
            </span>
          : null}

          <Button
            size='small'
            className={classnames(styles.button, styles.next, {
              [styles.disabled]: last,
            })}
            onClick={nextPage}
            type='default'
          >
            <FormattedMessage
              id='util.pagination_controls.next'
              defaultMessage='Next'
            />
          </Button>
        </div>
      : null}
    </div>
  )
}

PaginatorControls.propTypes = {
  current: PropTypes.number,
  pages: PropTypes.number,
  first: PropTypes.bool,
  last: PropTypes.bool,
  prevPage: PropTypes.func,
  nextPage: PropTypes.func,
  gotoPage: PropTypes.func,
  maxPageButtons: PropTypes.number,
  pageButtons: PropTypes.array,
  firstButtonIndex: PropTypes.number,
}

export default PaginatorControls



// WEBPACK FOOTER //
// ./src/components/util/PaginatorControls.jsx